import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=06ca4e10&scoped=true&"
import script from "./ColorBar.vue?vue&type=script&lang=js&"
export * from "./ColorBar.vue?vue&type=script&lang=js&"
import style0 from "./ColorBar.vue?vue&type=style&index=0&id=06ca4e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca4e10",
  null
  
)

export default component.exports